<template>
  <q-page>
    <div class="q-pa-md">
      <div class="row justify-between q-mb-md">
        <div class="row items-center">
          <div class="page-title q-mr-sm">Article Keywords</div>
          <div>
            <q-btn
              @click="onAddArticlesKeywords"
              color="primary"
              class="float-right sustainability-button"
              :loading="isLoading"
            >
              <q-icon name="mdi-plus-circle"> </q-icon>
              <span class="sustainability-font q-mx-sm" style="font-size: 13px">
                Add
              </span>
            </q-btn>
          </div>
        </div>
        <div>
          <q-input
            class="searchbar float-right"
            filled
            v-model="search"
            debounce="200"
            label="Search"
            clearable
            dense
          >
            <template #prepend>
              <q-icon name="mdi-magnify"></q-icon>
            </template>
          </q-input>
        </div>
      </div>
      <div class="row">
        <q-card
          flat
          class="full-width shadow-10 sustainability-card-radius"
          style="height: calc(100vh - 195px)"
        >
          <sustainability-datatable
            headerBgColor="#162c47"
            headerTextColor="white"
            :columns="columns"
            :data="data"
            @rowDoubleClick="onRowDoubleClick"
            :cellBodyStyle="cellBodyStyle"
          >
            <template slot="body-cell-actions" slot-scope="data">
              <q-td :props="data.props">
                <q-btn
                  class="float-right"
                  round
                  flat
                  color="red"
                  icon="mdi-delete"
                  @click="removeKeyword(data.props.row)"
                  size="md"
                >
                  <q-tooltip> Delete Article </q-tooltip>
                </q-btn>
              </q-td>
            </template>
          </sustainability-datatable>
        </q-card>
      </div>
    </div>

    <q-dialog v-model="formDialog" full-height full-width>
      <keywords-form @closeDialog="closeDialog"> </keywords-form>
    </q-dialog>
  </q-page>
</template>

<script>
import SustainabilityDatatable from "@/components/datatable/sustainabilityDatatable.vue";
import KeywordsForm from "@/components/keywords/keywordsForm.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    SustainabilityDatatable,
    KeywordsForm,
  },
  mounted() {
    this.$store.dispatch("keywords/loadAll");
    if (this.$route.params.hasOwnProperty("id")) {
      this.openSelectedKeyword(this.$route.params.id);
    }
  },
  computed: {
    ...mapGetters({
      data: "keywords/list",
    }),
    cellBodyStyle() {
      return "font-family: 'Montserrat';font-style: normal;font-weight: 400;font-size: 14px;line-height: 17px;display: flex;align-items: center;letter-spacing: -0.02em;color: black;";
    },
    columns() {
      return [
        {
          name: "id",
          label: "ID",
          align: "left",
          field: "id",
          style:
            "min-width: 60px;max-width: 60px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" +
            this.dataGridCSS,
          sortable: true,
        },
        {
          name: "keyword",
          label: "Keyword",
          align: "left",
          field: "keyword",
          style:
            "min-width:400px;max-width:400px;width: 400px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" +
            this.dataGridCSS,
          sortable: true,
        },
        {
          name: "createdAt",
          label: "Created At",
          align: "left",
          field: "created_at",
          format: (val) => {
            return this.$options.filters.gridDateFormat(val);
          },
          style:
            "min-width:300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" +
            this.dataGridCSS,
          sortable: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "right",
        },
      ];
    },
  },
  watch: {
    $route: {
      handler(value) {
        if (value.params.hasOwnProperty("id")) {
          this.openSelectedKeyword(value.params.id);
        }
      },
      deep: true,
    },
  },
  data: () => ({
    search: "",
    formDialog: false,
    isLoading: false,
  }),
  methods: {
    onRowDoubleClick(row) {
      this.$router.push("/articlesKeywords/" + row.id);
    },
    async onAddArticlesKeywords() {
      this.isLoading = true;
      let result = await this.$store.dispatch("keywords/new", {
        status: "temp",
      });
      this.$router.push(
        "/articlesKeywords/" + parseFloat(result.Response.newKeywordId)
      );
      this.isLoading = false;
    },
    openSelectedKeyword(id) {
      this.$store.commit("keywords/setSelectedKeyword", null);
      this.$store.dispatch("keywords/loadByID", id);
      this.$nextTick(() => (this.formDialog = true));
    },
    removeKeyword(row) {
      this.$swal({
        title: "Warning",
        text: "You are about to delete this Item. This is irreversible",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122",
      }).then(async (res) => {
        if (res.value) {
          let payload = { ...row };
          payload.deleted_at = new Date();
          this.$store.dispatch("keywords/save", payload).then((result) => {
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: "The Keyword has been removed.",
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
        }
      });
    },
    closeDialog() {
      this.$router.push("/articlesKeywords");
      this.formDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
}
</style>
